import { sameJson } from './same-json.js'

const cloneJson = value => JSON.parse(JSON.stringify(value))

/** A proposal keeps the complete source draft so adoption cannot overwrite newer edits. */
export function createOpeningProposal(source, opening) {
  return { source: cloneJson(source), opening: cloneJson(opening) }
}

export function openingProposalIsCurrent(current, proposal) {
  return proposal !== null && sameJson(current, proposal.source)
}

/** Only the opening changes; obsolete manually seeded opening threads are cleared. */
export function adoptOpeningProposal(current, proposal) {
  if (!openingProposalIsCurrent(current, proposal)) throw new Error('opening_proposal_stale')
  if (sameJson(current.opening, proposal.opening)) return current
  return { ...current, opening: cloneJson(proposal.opening), ...(Object.hasOwn(current, 'initial_threads') ? { initial_threads: [] } : {}) }
}
